module.exports = __webpack_public_path__ + "static/media/email-sent.daf92eb1.svg";